export const SET_NAME = 'SET_NAME';
export const SET_PROFILE_PIC = 'SET_PROFILE_PIC';